import React from 'react';

import { Button } from '@column/column-ui-kit';

import { HelpSidebarType } from '~/stores/HelpSidebar';
import { Box, Inner } from '~/styles';

import { BottomLinks, HelpSidebarBase } from './Base';
import { HelpSidebarList, HelpSidebarListItem } from './Onboarding';

export const HelpSidebarRoles: React.FC = () => {
  const helpSidebar: HelpSidebarType[] = ['Roles'];

  return (
    <HelpSidebarBase helpSidebars={helpSidebar} headline="Roles">
      <HelpSidebarList>
        <HelpSidebarListItem>
          <h4>Admin</h4>
          <p>
            Admins manage platform users, settings, and info. Full access to money movement and other enabled features.
            Can reset device authenticator for other users. Platform Owners are always Admin.
          </p>
        </HelpSidebarListItem>

        <HelpSidebarListItem>
          <h4>Developer</h4>
          <p>
            Developers manage platform API keys and webhooks. Full access to money movement and other enabled features.
            Developers cannot edit platform users, info, or settings.
          </p>
        </HelpSidebarListItem>

        <HelpSidebarListItem>
          <h4>Money Mover</h4>
          <p>
            Money Movers have full access to money movement and other enabled features. Money Movers cannot view
            platform users, info, settings, API keys, or webhooks.
          </p>
        </HelpSidebarListItem>

        <HelpSidebarListItem>
          <h4>Check Depositor</h4>
          <p>
            Check Depositors have access to deposit checks only. Check Depositors cannot view platform users, info,
            settings, API keys, or webhooks, and cannot perform an other money movement.
          </p>
        </HelpSidebarListItem>

        <HelpSidebarListItem>
          <h4>Viewer</h4>
          <p>
            Viewers can create reports, and view/export data. Viewers cannot view platform users, info, settings, API
            keys, or webhooks.
          </p>
        </HelpSidebarListItem>

        <HelpSidebarListItem>
          <Button
            onClick={() => window.open('https://column.com/docs/guides/roles-and-permissions', '_blank')}
            variant="secondary"
          >
            Learn more about Roles & Permissions
          </Button>
        </HelpSidebarListItem>

        <HelpSidebarListItem>
          <Box variant="secondary">
            <Inner py={12} px={16}>
              <p>Note: API keys aren't affected by roles or permissions.</p>
            </Inner>
          </Box>
        </HelpSidebarListItem>
      </HelpSidebarList>
      <BottomLinks />
    </HelpSidebarBase>
  );
};
